
import Icon from "@ant-design/icons";
import { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const CreditCardSVG = () => (
  <svg viewBox="0 0 24 24"  width="24" height="24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 4H4C2.89543 4 2 4.89543 2 6V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V6C22 4.89543 21.1046 4 20 4ZM20 6V8H4V6H20ZM4 18V11H20V18H4Z"/>
    <path d="M6 14H10V16H6V14Z"/>
    <path d="M12 14H14V16H12V14Z"/>
  </svg>
);

export const CreditCardIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={CreditCardSVG} {...props} />
);
